import React from 'react'
import { Provider } from 'react-redux'
import { getStore } from '@/store'
import { LocalizationProvider } from '@/components/localization'
import { FeatureFlagsProvider } from '@/components/featureFlagsProvider'

export function GlobalContextProviders (props) {
  return (
    <Provider store={getStore()}>
      <LocalizationProvider>
        <FeatureFlagsProvider>
          {props.children}
        </FeatureFlagsProvider>
      </LocalizationProvider>
    </Provider>
  )
}



// WEBPACK FOOTER //
// ./src/components/globalContextProviders.js